import axios from 'axios'

const host = import.meta.env.HOST_NAME || window.location.host
const protocol = window.location.protocol
const API_URL = `${protocol}//${host}`

const securedAxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Audience: 'cps-ors',
  },
})

const plainAxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Audience: 'cps-ors',
  },
})

securedAxiosInstance.interceptors.request.use((config) => {
  const method = config.method.toUpperCase()
  if (method !== 'OPTIONS' && method !== 'GET') {
    config.headers = {
      ...config.headers,
    }
  }
  return config
})

securedAxiosInstance.interceptors.response.use(null, (error) => {
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('cps-ors.authorization')
    securedAxiosInstance.router.push('/home')
  }

  return Promise.reject(error)
})

export const BackendPlugin = {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    if (!options.router) {
      throw new Error('You must supply a router instance in the options.')
    }

    securedAxiosInstance.router = options.router
    ;(Vue.prototype.$secured = securedAxiosInstance),
      (Vue.prototype.$plain = plainAxiosInstance)
  },
}
